import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)


export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            // title: '雨欣基因'
          }
        }, {
          path: '/solution',
          name: 'solution',
          component: resolve => require(['@/view/Solution'], resolve),
          meta: {
            // title: '解决方案'
          }
        }, {
          path: '/aboutUs',
          name: 'aboutUs',
          component: resolve => require(['@/view/AboutUs'], resolve),
          meta: {
            // title: '关于我们'
          }
        }, {
          path: '/aboutUs1',
          name: 'aboutUs1',
          component: resolve => require(['@/view/AboutUs1'], resolve),
          meta: {
            // title: '关于我们2'
          }
        }, {
          path: '/aboutUs2',
          name: 'aboutUs2',
          component: resolve => require(['@/view/AboutUs2'], resolve),
          meta: {
            // title: '关于我们3'
          }
        }, {
          path: '/aboutUs3',
          name: 'aboutUs3',
          component: resolve => require(['@/view/AboutUs3'], resolve),
          meta: {

          }
        }, {
          path: '/aboutUs4',
          name: 'aboutUs4',
          component: resolve => require(['@/view/AboutUs4'], resolve),
          meta: {

          }
        }, {
          path: '/aboutUs5',
          name: 'aboutUs5',
          component: resolve => require(['@/view/AboutUs5'], resolve),
          meta: {

          }
        }, {
          path: '/aboutUs6',
          name: 'aboutUs6',
          component: resolve => require(['@/view/AboutUs6'], resolve),
          meta: {

          }
        }, {
          path: '/newsCenter',
          name: 'newsCenter',
          component: resolve => require(['@/view/NewsCenter'], resolve),
          meta: {
            // title: '公司介绍'
          }
        }, {
          path: '/newsDetail/:id',
          name: 'newsDetail',
          component: resolve => require(['@/view/NewsDetail'], resolve),
          meta: {
            // title: '工作机会'
          }
        },{
          path: '/newsPage/:id',
          name: 'newsPage',
          component: resolve => require(['@/view/NewsPage'], resolve),
          meta: {
            // title: '工作机会'
          }
        }, {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          // component: resolve => require(['@/view/Software_bigData'], resolve),
          meta: {
            // title: '联系我们'
          }
        },
        {
          path: '/solutionDetail/:id',
          name: 'solutionDetail',
          component: resolve => require(['@/view/SolutionDetail'],resolve),
          meta: {
            // title: '解决方案详情'
          }
        },
        {
          path: '/product/instrumentPage/:id',
          name: 'product',
          component: resolve => require(['@/view/InstrumentPage'],resolve),
          meta: {
            // title: '仪器产品'
          }
        },
        {
          path: '/product/reagentPage/:id',
          name: 'product',
          component: resolve => require(['@/view/ReagentPage'],resolve),

          meta: {
            // title: '仪器产品'
          }
        },
        {
          path: '/product/softwarePage/:id',
          name: 'software',
          component: resolve => require(['@/view/SoftwarePage'],resolve),
          meta: {
            // title: '软件产品'
          }
        },{
          path: '/recruitment',
          name: 'recruitment',
          component: resolve => require(['@/view/Recruitment'],resolve),
          meta: {
            // title: '人才招聘'
          }
        },{
          path: '/recruitmentDetails/:id',
          name: 'recruitmentDetails',
          component: resolve => require(['@/view/RecruitmentDetails'],resolve),
          meta: {
            // title: '招聘详情'
          }
        },

      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js